import { gql } from "@apollo/client";

const ACTIVATE_DESTINATION = gql`
mutation ActivateDestination($id: String){
    activateDestination(id: $id)
    }
`;

export default ACTIVATE_DESTINATION;
